import React from 'react';
import { Instagram, Mail, MessageCircle } from 'lucide-react';
export function Footer() {
  return <footer className="bg-earia-bg border-t border-earia-border py-12" data-id="element-154">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-155">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-156">
          <div className="flex items-center gap-2 mb-4 md:mb-0" data-id="element-157">
            <div className="w-10 h-8 bg-earia-accent rounded-lg flex items-center justify-center shadow-sm" data-id="element-158">
              <span className="text-earia-text-heading font-bold tracking-tight text-[18px]" data-id="element-159">
                EAR
              </span>
            </div>
            <span className="text-earia-text-heading font-bold tracking-tight text-[16px]" data-id="element-160">
              Import{' '}
              <span style={{
              color: '#d42323'
            }} data-id="element-161">
                Auto
              </span>
            </span>
          </div>

          <div className="text-earia-text-body text-sm mb-4 md:mb-0" data-id="element-162">
            © 2026 EARIA. San Salvador, El Salvador.
          </div>

          <div className="flex flex-col items-center md:items-end" data-id="element-163">
            <span className="text-earia-text-body text-xs uppercase tracking-wider mb-2" data-id="element-164">
              Contactos
            </span>
            <div className="flex items-center space-x-6" data-id="element-165">
              <a href="https://wa.me/50379473074" target="_blank" rel="noopener noreferrer" className="text-earia-text-body hover:text-green-500 transition-colors" title="WhatsApp" data-id="element-166">
                <span className="sr-only" data-id="element-167">WhatsApp</span>
                <MessageCircle className="h-5 w-5" data-id="element-168" />
              </a>
              <a href="mailto:earivassb@gmail.com" className="text-earia-text-body hover:text-earia-accent transition-colors" title="Email" data-id="element-169">
                <span className="sr-only" data-id="element-170">Email</span>
                <Mail className="h-5 w-5" data-id="element-171" />
              </a>
              <a href="https://www.instagram.com/earia.sv/" target="_blank" rel="noopener noreferrer" className="text-earia-text-body hover:text-earia-accent transition-colors" title="Instagram" data-id="element-172">
                <span className="sr-only" data-id="element-173">Instagram</span>
                <Instagram className="h-5 w-5" data-id="element-174" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}